













import { Component, Vue } from "vue-property-decorator";
import { container } from "@/services/registerServiceProvider";
import { IAppService } from "@/services/IAppService";

@Component
export default class FooterCmpt extends Vue {
  public readonly appService: IAppService = container.resolve("IAppService");
}
